var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-textarea',{attrs:{"rows":3,"max-rows":6,"readonly":_vm.readonly},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }